import {gsap} from "gsap";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class MaxWinView extends PIXI.Container {

    private _spine: PIXI.spine.Spine;
    private _wincapTimes: PIXI.BitmapText;

    constructor() {
        super();
        this.name = "MaxWinView";
        this.visible = false;
        this.init();
    }




    public showMaxWin(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            // this.onResize();
            this.visible = true;
            this._spine.visible = true;
            this._wincapTimes.visible = true;
            this._spine.alpha = 1;
        }, 0);
        if(!XwaysHoarder2.darkOverlay.isOverlayVisible){
            XwaysHoarder2.darkOverlay.addOverlay();
        }

        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this._spine, 0, "capWin Start", false));
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this._spine, 0, "capWin End", false));


        return tl;
    }

    public showWinCapTimes(): gsap.core.Timeline {
        return gsap.timeline().to(this._wincapTimes, {duration: 0.25, ease: "none", alpha: 1});
    }

    public hideMaxwin(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        //tl.add(() => {
            //XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.CAP_LOOP);
        //});
        tl.add(() => {
            XwaysHoarder2.buyFeatureName = "";
            XwaysHoarder2.backgroundElements.setBackground(GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.foregroundElements.setForeground(XW2GameMode.NORMAL, XwaysHoarder2.model.data.mode, true);
            XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.NORMAL);
        });

        tl.add(XwaysHoarder2.darkOverlay.hideOverlay(0.5));
        tl.to([this._spine, this._wincapTimes], {duration: 0.5, ease: "none", alpha: 0}, "<");
        tl.add(() => {
            this.visible = false;
            this._wincapTimes.visible = false;
            this._spine.visible = false;
        })

        return tl;
    }

    private init(): void {


        this._spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.WIN_CAP_SPINE));
        this._spine.position.set(360, 360);
        this._spine.alpha = 0;
        this._spine.visible = false;
        this._spine.name = "wincapSpine";

        this._wincapTimes = new PIXI.BitmapText("25920x", {
            fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
            fontSize: 90,
        });
        this._wincapTimes.name = "25920x";
        this._wincapTimes.anchor = new PIXI.Point(0.5, 0.5);
        this._wincapTimes.position.set(360, 500);
        this._wincapTimes.alpha = 0;
        this._wincapTimes.visible = false;


        this.addChild(this._spine);
        this.addChild(this._wincapTimes);

    }


}